import React, { useEffect } from 'react';
import '../styles/PricingPage.css';
import '../styles/buttons.css';
import Header from '../components/Header';
import CheckMark from '../assets/check-mark.png';  

const PricingPage = () => {
  useEffect(() => {
    document.body.classList.add('pricing-page-body');
    return () => {
      document.body.classList.remove('pricing-page-body');
    };
  }, []);

  return (
    <div className="pricing-page">
      <Header />

      <div className="content-above-cards"> 
        <header className="pricing-header">
          <h1 className="pricing-tagline">Plans & Pricing</h1>
          <p className="pricing-subheading">Get Started for Free and Choose the Plan that Fits Your Needs.</p>
          <p className="pricing-description">Pick the Perfect Plan for Your Event. Upgrade or Adjust as Your Needs Evolve.</p>

          <div className="email-trial">
            <input type="email" placeholder="Enter your email address" />
            <button type="button" className="btn btn-primary">
              Request a trial
            </button>
          </div>
          <p className="no-credit-info">
            Try BestDay2Marry free, no credit card required. By entering your email, you agree to receive marketing emails from BestDay2Marry.
          </p>
        </header>
      </div>

      <div className="pricing-cards-container">
        <header className="plans-header">
          <h2>Business Plans</h2>
        </header>

        <div className="pricing-cards">
          <div className="pricing-card">
            <h3 className="plan-title">Trial</h3>
            <p className="price">Free</p>
            {/* <p className="access-type">One-time Access:</p> */}
            <div className="card-divider"></div> 
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />1 week access</li>
              <li><img src={CheckMark} alt="Check" />1 location</li>
              <li><img src={CheckMark} alt="Check" />1 date</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
            </ul>
            <button type="button" className="btn btn-primary">Try for free</button>
          </div>

          <div className="pricing-card">
            <h3 className="plan-title">Standard</h3>
            <p className="price">$500 <span>/ month</span></p>
            <div className="card-divider"></div>
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />1 location</li>
              <li><img src={CheckMark} alt="Check" />1 date</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
            </ul>
            <button type="button" className="btn btn-primary">Get started</button>
          </div>

          <div className="pricing-card">
            <h3 className="plan-title">Premium</h3>
            <p className="price">$700 <span>/ monthly</span></p>
            { /* <p className="save-info">You save $80</p> */ }
            { /* <div className="custom-card-divider"></div> */ }
            <div className="card-divider"></div>
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />1 location</li>
              <li><img src={CheckMark} alt="Check" />1 date</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
              <li><img src={CheckMark} alt="Check" />Extreme Weather: Fires, Flooding, Storms</li>
            </ul>
            <button type="button" className="btn btn-primary">Get started</button>
          </div>

          <div className="pricing-card">
            <h3 className="plan-title">Custom</h3>
            <p className="price">Price varies <span>/ monthly</span></p>
            <div className="card-divider"></div>
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />Choose locations</li>
              <li><img src={CheckMark} alt="Check" />Choose number of dates</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
              <li><img src={CheckMark} alt="Check" />Extreme Weather: Fires, Flooding, Storms</li>
            </ul>
            <button className="cta-button">Call Us</button>
          </div>
        </div>
      </div>

      <div className="pricing-cards-container">
      <header className="plans-header">
          <h2>Couples' Plans</h2>
          <h3>Coming soon</h3>
        </header>

        <div className="pricing-cards">
          <div className="pricing-card">
            <h3 className="plan-title">Trial</h3>
            <p className="price">Free</p>
            {/* <p className="access-type">One-time Access:</p> */}
            <div className="card-divider"></div> 
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />1 week access</li>
              <li><img src={CheckMark} alt="Check" />1 location</li>
              <li><img src={CheckMark} alt="Check" />1 date</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
            </ul>
            <button className="cta-button">Try for free</button>
          </div>

          <div className="pricing-card">
            <h3 className="plan-title">Essentials</h3>
            <p className="price">$10 <span>/ per use</span></p>
            <div className="card-divider"></div>
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />1 location</li>
              <li><img src={CheckMark} alt="Check" />Any date</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
            </ul>
            <button type="button" className="btn btn-primary">Get started</button>
          </div>

          <div className="pricing-card">
            <h3 className="plan-title">Standard</h3>
            <p className="price">$50 <span>/ monthly</span></p>
            { /* <p className="save-info">You save $80</p> */ }
            { /* <div className="custom-card-divider"></div> */ }
            <div className="card-divider"></div>
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />Any location</li>
              <li><img src={CheckMark} alt="Check" />Any date</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
            </ul>
            <button type="button" className="btn btn-primary">Get started</button>
          </div>

          <div className="pricing-card">
            <h3 className="plan-title">Premium</h3>
            <p className="price">$520 <span>/ yearly</span></p>
            <div className="card-divider"></div>
            <ul className="features-list">
              <li><img src={CheckMark} alt="Check" />Any location</li>
              <li><img src={CheckMark} alt="Check" />Any date</li>
              <li><img src={CheckMark} alt="Check" />Updated on monthly basis forecasts</li>
              <li><img src={CheckMark} alt="Check" />Temperature</li>
              <li><img src={CheckMark} alt="Check" />Humidity</li>
              <li><img src={CheckMark} alt="Check" />Wind</li>
              <li><img src={CheckMark} alt="Check" />Clouds</li>
              <li><img src={CheckMark} alt="Check" />Precipitation</li>
              <li><img src={CheckMark} alt="Check" />Sunrise/Sunset</li>
              <li><img src={CheckMark} alt="Check" />Extreme Weather: Fires, Flooding, Storms</li>
            </ul>
            <button type="button" className="btn btn-primary">Get started</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
